import __vue_component__$4 from './MdButton.js';
import { n as normalizeComponent } from './normalize-component-cf2db48b.js';
import __vue_component__$5 from './MdInkRipple.js';
import __vue_component__$6 from './MdListItemExpand.js';
import './browser-ac904bdc.js';
import './getClosestVueParent-2f2cbc16.js';
import './MdIcon.js';

var TabNavigationMixin = {
  methods: {
    TabNavigationMixin_focusElement($event, moveTo) {
      const target = $event === null || $event === void 0 ? void 0 : $event.target;
      if (!!target) {
        if (moveTo === "next" && !!target.nextElementSibling) {
          target.nextElementSibling.focus();
        }
        if (moveTo === "prev" && !!target.previousElementSibling) {
          target.previousElementSibling.focus();
        }
      }
    }
  }
};

var script$3 = {
  name: "md-list-item",
  components: {
    MdButton: __vue_component__$4
  },
  mixins: [TabNavigationMixin],
  props: {
    disabled: Boolean,
    breakLines: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      return {
        "md-disabled": this.disabled
      };
    }
  },
  methods: {
    fireClick() {
      this.$refs.intemButton.$el.click();
    }
  }
};

const __vue_script__$3 = script$3;
var __vue_render__$3 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('li', {
    staticClass: "md-list-item",
    class: _vm.classes,
    on: {
      "keyup": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }
        return _vm.fireClick.apply(null, arguments);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) {
          return null;
        }
        return _vm.TabNavigationMixin_focusElement($event, 'next');
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "right", 39, $event.key, ["Right", "ArrowRight"])) {
          return null;
        }
        if ('button' in $event && $event.button !== 2) {
          return null;
        }
        return _vm.TabNavigationMixin_focusElement($event, 'next');
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) {
          return null;
        }
        return _vm.TabNavigationMixin_focusElement($event, 'prev');
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "left", 37, $event.key, ["Left", "ArrowLeft"])) {
          return null;
        }
        if ('button' in $event && $event.button !== 0) {
          return null;
        }
        return _vm.TabNavigationMixin_focusElement($event, 'prev');
      }]
    }
  }, [_c('div', {
    staticClass: "md-list-item-container md-button",
    class: {
      'md-list-item-container--break-lines': _vm.breakLines
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('md-button', {
    ref: "intemButton",
    staticClass: "md-button-ghost",
    attrs: {
      "type": "button",
      "tabindex": "-1",
      "disabled": _vm.disabled,
      "border-style": 'none'
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click', $event);
      }
    }
  })], 1);
};
var __vue_staticRenderFns__$3 = [];
const __vue_inject_styles__$3 = undefined;
const __vue_scope_id__$3 = undefined;
const __vue_module_identifier__$3 = undefined;
const __vue_is_functional_template__$3 = false;
const __vue_component__$3 = normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, undefined, undefined, undefined);
var MdListItemButton = __vue_component__$3;

var script$2 = {
  name: "md-list-item",
  components: {
    MdInkRipple: __vue_component__$5
  },
  props: {
    href: String,
    target: String,
    disabled: Boolean
  },
  computed: {
    classes() {
      return {
        "md-disabled": this.disabled
      };
    }
  }
};

const __vue_script__$2 = script$2;
var __vue_render__$2 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('li', {
    staticClass: "md-list-item",
    class: _vm.classes
  }, [_c('a', {
    staticClass: "md-list-item-container md-button",
    attrs: {
      "href": _vm.href,
      "target": _vm.target,
      "disabled": _vm.disabled
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click', $event);
      }
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('md-ink-ripple', {
    attrs: {
      "disabled": _vm.disabled
    }
  })], 1);
};
var __vue_staticRenderFns__$2 = [];
const __vue_inject_styles__$2 = undefined;
const __vue_scope_id__$2 = undefined;
const __vue_module_identifier__$2 = undefined;
const __vue_is_functional_template__$2 = false;
const __vue_component__$2 = normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, undefined, undefined, undefined);
var MdListItemLink = __vue_component__$2;

var script$1 = {
  name: "md-list-item",
  components: {
    MdInkRipple: __vue_component__$5
  },
  props: {
    disabled: Boolean
  },
  computed: {
    classes() {
      return {
        "md-disabled": this.disabled
      };
    }
  }
};

const __vue_script__$1 = script$1;
var __vue_render__$1 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('li', {
    staticClass: "md-list-item",
    class: _vm.classes,
    attrs: {
      "disabled": _vm.disabled
    }
  }, [_vm._t("default"), _vm._v(" "), _c('md-ink-ripple', {
    attrs: {
      "disabled": _vm.disabled
    }
  })], 2);
};
var __vue_staticRenderFns__$1 = [];
const __vue_inject_styles__$1 = undefined;
const __vue_scope_id__$1 = undefined;
const __vue_module_identifier__$1 = undefined;
const __vue_is_functional_template__$1 = false;
const __vue_component__$1 = normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, undefined, undefined, undefined);
var MdListItemRouter = __vue_component__$1;

var script = {
  name: "md-list-item"
};

const __vue_script__ = script;
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('li', {
    staticClass: "md-list-item"
  }, [_c('div', {
    staticClass: "md-list-item-container"
  }, [_vm._t("default")], 2)]);
};
var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_module_identifier__ = undefined;
const __vue_is_functional_template__ = false;
const __vue_component__ = normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);
var MdListItemDefault = __vue_component__;

const MdListItem = {
  functional: true,
  props: {
    href: String,
    disabled: Boolean,
    iconColor: {
      type: String,
      default: "currentColor"
    },
    breakLines: {
      type: Boolean,
      default: false
    },
    disableInput: {
      type: Boolean,
      default: false
    }
  },
  render(createElement, {
    children,
    data,
    props
  }) {
    const getItemComponent = () => {
      const on = data.on;
      const interactionEvents = ["contextmenu", "dblclick", "dragend", "mousedown", "touchstart", "click"];
      let childrenCount = children.length;
      if (props.href) {
        return MdListItemLink;
      }
      while (childrenCount--) {
        const options = children[childrenCount].componentOptions;
        if (options) {
          if (options.tag === "md-list-expand") {
            const expandComponent = children[childrenCount];
            data.scopedSlots = {
              expand: () => expandComponent
            };
            children.splice(childrenCount, 1);
            return __vue_component__$6;
          } else if (options.tag === "router-link") {
            children[childrenCount].data.staticClass = "md-list-item-container md-button";
            return MdListItemRouter;
          }
        }
      }
      if (on) {
        let counter = interactionEvents.length;
        while (counter--) {
          if (on[interactionEvents[counter]]) {
            return MdListItemButton;
          }
        }
      }
      return MdListItemDefault;
    };
    return createElement(getItemComponent(), {
      props,
      ...data
    }, children);
  }
};

export { MdListItem as default };
